var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpiredLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 109,
    viewBox: "0 0 153 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.949 27.5781H19.2787C16.9979 27.5781 14.9937 29.5824 14.9937 31.8632V103.188C14.9937 105.469 16.9979 104.64 19.2787 104.64H122.673C124.953 104.64 126.958 105.469 126.958 103.188V31.8632C127.234 29.5824 125.23 27.5781 122.949 27.5781Z",
    fill: "#F1F3F9",
    stroke: "#D6DBE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.296 100.633V102.914C140.296 105.471 138.016 107.752 135.458 107.752H6.83796C4.28075 107.752 2 105.471 2 102.914V100.633H140.296Z",
    fill: "white",
    stroke: "#D6DBE8",
    strokeWidth: 2.1011,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3837 100.633V101.462C84.3837 102.914 83.2779 104.296 81.55 104.296H60.4704C59.019 104.296 57.6367 103.19 57.6367 101.462V100.633H84.3837Z",
    fill: "#F1F3F9",
    stroke: "#D6DBE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.863 36.91V93.445C114.725 95.7949 112.858 97.7301 110.44 97.7301H26.6738C24.1857 97.7301 22.2505 95.7949 22.2505 93.445V36.91C22.2505 34.5602 24.1857 32.625 26.6738 32.625H110.509C112.997 32.625 114.863 34.5602 114.863 36.91Z",
    fill: "#F1F3F9",
    stroke: "#D6DBE8",
    strokeWidth: 2.1011,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2959 39.1211C28.1253 39.1211 28.8164 38.4299 28.8164 37.6006C28.8164 36.7712 28.1253 36.0801 27.2959 36.0801C26.4665 36.0801 25.7754 36.7712 25.7754 37.6006C25.7754 38.4299 26.4665 39.1211 27.2959 39.1211Z",
    fill: "#D6DBE8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7881 39.1211C32.6174 39.1211 33.3086 38.4299 33.3086 37.6006C33.3086 36.7712 32.6174 36.0801 31.7881 36.0801C30.9587 36.0801 30.2676 36.7712 30.2676 37.6006C30.2676 38.4299 30.9587 39.1211 31.7881 39.1211Z",
    fill: "#D6DBE8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4189 39.1211C37.2483 39.1211 37.9394 38.4299 37.9394 37.6006C37.9394 36.7712 37.2483 36.0801 36.4189 36.0801C35.5896 36.0801 34.8984 36.7712 34.8984 37.6006C34.8984 38.4299 35.5896 39.1211 36.4189 39.1211Z",
    fill: "#F1F3F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M114.863 36.91V91.7863H32.6176C30.1295 91.7863 28.1943 89.8511 28.1943 87.5012V32.625H110.44C112.997 32.625 114.863 34.5602 114.863 36.91Z",
    fill: "#D6DBE8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.4 27.4413V83.9763C124.4 84.0454 124.4 84.1836 124.4 84.2527C124.193 86.5335 122.327 88.2613 120.046 88.2613H36.2114C33.7233 88.2613 31.7881 86.3261 31.7881 83.9763V27.4413C31.7881 25.0914 33.7233 23.1562 36.2114 23.1562H120.046C122.534 23.1562 124.4 25.0223 124.4 27.4413Z",
    fill: "#F1F3F9",
    stroke: "#D6DBE8",
    strokeWidth: 2.1011,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8335 29.6523C37.6629 29.6523 38.354 28.9612 38.354 28.1318C38.354 27.3025 37.6629 26.6113 36.8335 26.6113C36.0041 26.6113 35.313 27.3025 35.313 28.1318C35.313 28.9612 36.0041 29.6523 36.8335 29.6523Z",
    fill: "#D6DBE8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3262 29.6523C42.1555 29.6523 42.8467 28.9612 42.8467 28.1318C42.8467 27.3025 42.1555 26.6113 41.3262 26.6113C40.4968 26.6113 39.8057 27.3025 39.8057 28.1318C39.8057 28.9612 40.4968 29.6523 41.3262 29.6523Z",
    fill: "#D6DBE8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9565 29.6523C46.7859 29.6523 47.477 28.9612 47.477 28.1318C47.477 27.3025 46.7859 26.6113 45.9565 26.6113C45.1272 26.6113 44.436 27.3025 44.436 28.1318C44.436 28.9612 45.1272 29.6523 45.9565 29.6523Z",
    fill: "#F1F3F9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M124.4 27.4401V83.9751C124.4 84.0442 124.4 84.1824 124.4 84.2515H42.7768C40.2887 84.2515 38.3535 82.3163 38.3535 79.9665V23.3624C38.3535 23.2933 38.3535 23.1551 38.3535 23.0859H119.977C122.534 23.1551 124.4 25.0211 124.4 27.4401Z",
    fill: "#D6DBE8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M134.214 75.82C134.076 78.1699 132.21 80.1051 129.791 80.1051H46.0248C43.5367 80.1051 41.6016 78.1699 41.6016 75.82V19.285C41.6016 16.9352 43.5367 15 46.0248 15H129.86C132.348 15 134.283 16.9352 134.283 19.285V75.82H134.214Z",
    fill: "white",
    stroke: "#D6DBE8",
    strokeWidth: 2.1011,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6016 24.8828H134.076",
    stroke: "#D6DBE8",
    strokeWidth: 2.1011,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6475 21.5652C47.4768 21.5652 48.168 20.8741 48.168 20.0447C48.168 19.2153 47.4768 18.4551 46.6475 18.4551C45.8181 18.4551 45.127 19.1462 45.127 19.9756C45.127 20.8049 45.8181 21.5652 46.6475 21.5652Z",
    fill: "#AAB1C5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1396 21.5652C51.969 21.5652 52.6601 20.8741 52.6601 20.0447C52.6601 19.2153 51.969 18.4551 51.1396 18.4551C50.3103 18.4551 49.6191 19.1462 49.6191 19.9756C49.6191 20.8049 50.3103 21.5652 51.1396 21.5652Z",
    fill: "#AAB1C5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.77 21.5652C56.5994 21.5652 57.2905 20.8741 57.2905 20.0447C57.2905 19.2153 56.5994 18.4551 55.77 18.4551C54.9407 18.4551 54.2495 19.1462 54.2495 19.9756C54.2495 20.8049 54.8715 21.5652 55.77 21.5652Z",
    fill: "#AAB1C5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8103 40.5033C81.8103 42.1739 80.4561 43.5281 78.7855 43.5281C77.115 43.5281 75.7607 42.1739 75.7607 40.5033C75.7607 38.8328 77.115 37.4785 78.7855 37.4785C80.4561 37.4785 81.8103 38.8328 81.8103 40.5033Z",
    fill: "#AAB1C5",
    stroke: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6741 40.5033C98.6741 42.1739 97.3199 43.5281 95.6493 43.5281C93.9788 43.5281 92.6245 42.1739 92.6245 40.5033C92.6245 38.8328 93.9788 37.4785 95.6493 37.4785C97.3199 37.4785 98.6741 38.8328 98.6741 40.5033Z",
    fill: "#AAB1C5",
    stroke: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6122 58.6107H79.8218C77.472 58.6107 76.1588 55.9844 77.5411 54.0492C78.5778 52.5978 79.891 51.4229 81.4115 50.5244C83.1393 49.5568 85.1436 49.0039 87.217 49.0039C89.7051 49.0039 91.9859 49.7642 93.921 51.0773C95.096 51.9067 96.1327 52.8743 96.962 54.0492C98.2752 55.9844 96.962 58.6107 94.6122 58.6107Z",
    fill: "#D6DBE8",
    stroke: "#D6DBE8",
    strokeWidth: 1.7035,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4006 58.6109H82.1026C82.0335 58.4727 82.0335 58.3345 82.1026 58.1962C82.8629 56.0537 84.8672 54.5332 87.2861 54.5332C89.7051 54.5332 91.7094 56.0537 92.4697 58.1962C92.4697 58.3345 92.4697 58.4727 92.4006 58.6109Z",
    fill: "#AAB1C5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9209 51.7687V52.3216C93.9209 52.7363 93.5754 53.0128 93.2298 53.0128H82.1716C81.7569 53.0128 81.4805 52.6672 81.4805 52.3216V51.2158C83.2083 50.2482 85.2126 49.6953 87.286 49.6953C89.705 49.6953 91.9857 50.4556 93.9209 51.7687Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M122.949 58.6113H137.601C138.499 58.6113 139.329 58.9569 139.951 59.5789L150.318 69.946C150.94 70.568 151.285 71.3974 151.285 72.2958V86.8788C151.285 87.7773 150.94 88.6067 150.318 89.2287L140.089 99.4575C139.467 100.08 138.638 100.425 137.739 100.425H122.949C122.05 100.425 121.221 100.08 120.599 99.4575L110.094 88.9522C109.472 88.3302 109.126 87.5008 109.126 86.6024V72.2958C109.126 71.3974 109.472 70.568 110.094 69.946L120.53 59.5789C121.221 58.9569 122.05 58.6113 122.949 58.6113Z",
    fill: "#D6DBE8",
    stroke: "#AAB1C5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M133.613 75.4737L133.615 75.4627L133.616 75.4517C133.694 74.8584 133.694 74.3412 133.694 73.8871V73.8688V66.9329C133.694 65.8118 132.736 65.2004 132.022 65.0867L131.944 65.0742H131.865H128.616C127.623 65.0742 126.718 65.8761 126.718 66.9329V73.8688L126.718 73.9033C126.718 74.4068 126.718 74.9333 126.798 75.4698L126.798 75.4698L126.798 75.4737L127.559 80.4278L127.56 80.4379L127.562 80.4479C127.646 80.9296 127.925 81.3136 128.24 81.5671C128.556 81.8215 128.979 82.0028 129.446 82.0028H130.966C131.945 82.0028 132.699 81.3142 132.85 80.4479L132.851 80.4379L132.853 80.4278L133.613 75.4737Z",
    fill: "white",
    stroke: "#AAB1C5",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M128.478 92.4385H131.865C132.97 92.4385 133.901 91.507 133.901 90.4018V87.0152C133.901 85.91 132.97 84.9785 131.865 84.9785H128.478C127.373 84.9785 126.441 85.91 126.441 87.0152V90.4018C126.441 91.507 127.373 92.4385 128.478 92.4385Z",
    fill: "white",
    stroke: "#AAB1C5",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3297 10.3046L39.459 1.35352",
    stroke: "#AAB1C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0961 14.5374L27 5.94922",
    stroke: "#AAB1C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M36.556 20.2241L27.9678 19.7402",
    stroke: "#AAB1C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M140.781 17.1127L150.035 13.9774",
    stroke: "#AAB1C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M136.859 12.565L146.413 1.16016",
    stroke: "#AAB1C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M131.431 9.43748L132.661 1",
    stroke: "#AAB1C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredLink);
export default __webpack_public_path__ + "static/media/expired-link.svg";
export { ForwardRef as ReactComponent };